import * as React from 'react';
import * as Yup from 'yup';

import { useFormik } from 'formik';

import InputAdornment from '@mui/material/InputAdornment';
// icons
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//import { useSnackbar } from 'notistack';

// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// 
import { useTranslation } from 'react-i18next';


const theme = createTheme();

export default function LoginForm({email}) {
    //const { translate } = useLocales();
    const { login, role } = useAuth();
    const isMountedRef = useIsMountedRef();
    //const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    //const [showPassword, setShowPassword] = useState(false);
    const { t } = useTranslation();
  
    const LoginSchema = Yup.object().shape({
      email: Yup.string()
        .email(t("yup.errors.email_not_valid"))
        .required(t("yup.errors.email_required")),
      password: Yup.string().required(t("yup.errors.password_required")),
    });
  
    const formik = useFormik({
      initialValues: {
        email: '',
        password: '',
        // Remember me
        // remember: true
      },
      validationSchema: LoginSchema,
      onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
        try {
          await login(values.email, values.password);

          if (isMountedRef.current) {
            setSubmitting(false);
          }

          // Redirect to otp verification page using GuestGuard
        } catch (error) {
          console.error(error);

          const errorMessage = Object.values(error.data)[0][0]
          setErrors({ afterSubmit: errorMessage });
  
          if (isMountedRef.current) {
            if (error.status === 422) {
                setErrors({ afterSubmit: errorMessage });
                resetForm();
            } else if (error.status === 401) {
              // Reset password
              resetForm({
                values: {
                  email: values.email,
                  password: ''
                },
              });
              setErrors({ afterSubmit: t(error.data.message) }); // translate('auth.login.username_not_validated')
            } else {
                setErrors({ afterSubmit: error.data.message });
            }
  
            setSubmitting(false);
          }
        }
      }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (

      <Container component="div" sx={{ m: 0, p: 0, maxWidth: "unset !important" }}>
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 0,
            m: 0,
          }}
        >

          <Typography component="h1" variant="h4" sx={{ color: '#004990', fontWeight: 'bold' }}>
            {t("authentication.login.title")}
          </Typography>

          <Typography variant="caption" sx={{ pt: 1, pb: 3, fontSize: '13px', textAlign: 'center' }}>
            {t("authentication.login.subtitle")}
          </Typography>


          <form onSubmit={formik.handleSubmit}>
              {errors.afterSubmit && <Alert severity="error" sx={{mt: 2, mb: 1}}>{errors.afterSubmit}</Alert>}

              <TextField
                margin="normal"
                variant="outlined"
                
                fullWidth
                id="email"
                placeholder={t("authentication.fields.email")}
                name="email"
                autoComplete="email"
                autoFocus
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                sx={styles.inputText}

                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutlineIcon sx={{ color: "#6369E9" }} />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                margin="normal"
                variant="outlined"

                fullWidth
                name="password"
                placeholder={t("authentication.fields.password")}
                type="password"
                id="password"
                autoComplete="current-password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                sx={styles.inputText}

                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon sx={{ color: "#6369E9" }} />
                    </InputAdornment>
                  ),
                }}
              />

              {/* <FormControlLabel
                control={<Checkbox value="remember" sx={{ m: 0, p: 0, ml: '-2px', pr: '.7rem', color: "#6369E9", borderBlockColor: "#707070" }} />}
                label={<Typography variant="body2">Ricordami</Typography>}
                sx={{
                  m: 0,
                  pt: '.7rem',
                  width: '100%',
                }}
              /> */}

              <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 4, textAlign: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ 
                    width: '50%',
                    p: '8px 50px', 
                    backgroundColor: '#2CA4DE' 
                  }}
                >
                  {t("authentication.login.submit")}
                </Button>

                <Link href="/auth/password/request" variant="body2">
                  {t("authentication.reset_password_link")}
                </Link>
              </Stack>

            </form>
          </Box>

      </Container>
  );
}

const styles = {
  inputText: {
    // backgroundColor: '#EEF2F6',
    border: '0px solid',
    // p: '1rem',
    borderRadius: '10px',
  },
}